// extracted by mini-css-extract-plugin
export default {"select":"languageBlock_select__fxWxd","dropdown":"languageBlock_dropdown__jjnB6","iso-code":"languageBlock_iso-code__b2y3n"};